import { Trans } from 'react-i18next';
import { ReactElement } from 'react';

import { Text, Box } from 'libComponents';
import StartPageFooter from 'components/StartPageFooter';
import StartPageCard from 'components/StartPageCard';
import FooterWithPolicy from 'components/FooterWithPolicy';

import styles from './StartWithCardsContainer.module.css';

import { IGender } from 'types/commonInterfaces';
import { IStartWithCardsContainerProps } from './types';

function StartWithCardsContainer({
    pageTitles,
    cardsData,
    toNextPage,
    withPolicyFooter,
    titleType,
    indexPage,
    loginClick,
}: IStartWithCardsContainerProps): ReactElement {
    const selectCard = (value: IGender) => toNextPage(value);

    return (
        <>
            <Box paddingX={16} className={styles.container} paddingTop={78} paddingBottom={12}>
                <div className={styles.titlesWrapper}>
                    <Text as="h1" text={pageTitles.firstTitle} center type={titleType || 'h5'} mb={11} />
                    {pageTitles.secondTitle && (
                        <Text
                            text={pageTitles.secondTitle}
                            center
                            color="text-secondary"
                            type="large-text"
                            bold
                            mb={20}
                        />
                    )}
                    {pageTitles?.thirdTitle && <Text text={pageTitles.thirdTitle} center bold mb={14} />}
                </div>
                <div className={styles.cardsBox}>
                    {cardsData.map((card, index) => (
                        <StartPageCard
                            withoutCheck
                            onClick={() => selectCard(card.value)}
                            key={index}
                            title={card.title}
                            img={card.img}
                            dataLocator={card.dataLocator}
                            buttonColor={card.buttonColor}
                        />
                    ))}
                </div>
                <div className={styles.policyFooterWrapper}>
                    <StartPageFooter />
                </div>
                {indexPage && (
                    <button data-locator="StartLoginButton" onClick={loginClick} className={styles.loginLink}>
                        <Trans i18nKey="endFlow.registration.stepLogin" />
                    </button>
                )}
            </Box>
            {withPolicyFooter && <FooterWithPolicy />}
        </>
    );
}

export default StartWithCardsContainer;
